import { configureStore } from '@reduxjs/toolkit'
import sitedataReducer from './sitedataSlice'

export default configureStore({
  reducer: {
    sitedata: sitedataReducer,
    },
})